import { Typography, Dialog, DialogTitle, DialogActions, DialogContent, Button, Divider, Alert, Box, Card, CardActionArea } from "@mui/material";
import {  Grid, MenuItem, TextField, Select, FormControl, InputLabel, InputAdornment, IconButton } from "@mui/material";
import { afbInvestmentCreate, afbInvestmentComplete } from '../../../util/DataObject';
import { PostAdd, Engineering, SearchOutlined } from "@mui/icons-material";
import { useInvestmentAdmin } from "./hooks/useInvestmentAdmin";
import { ModalStyle } from "../../../util/Styles";

const AfbInvestmentAdmin = ({ open, changeAlert, changeLoader }) => {
    const { zPos, form, error, units, searchForm, isValidForm, selectedForm, onSelectForm, onHandleChange, onHandleSearch, onSearch, onConfirm, onClose } = useInvestmentAdmin(open, changeAlert, changeLoader);

    const showFields = (prop1, prop2, label, type, select = null) => {
        if (select) {
            return (
                <FormControl variant='outlined' fullWidth key={`${prop1}-${prop2}`}>
                    <InputLabel>{label}</InputLabel>
                    <Select sx={{ maxHeight: 40 }} label={label} value={form ? (form[prop2] || (form[prop1] && form[prop1][prop2]) || -1) : -1} onChange={onHandleChange.bind(this, prop1, prop2)} color="primary" fullWidth >
                        <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        {select === "unit"  && units?.map((item) => (
                            <MenuItem key={`${prop1}-${prop2}-${item.key}`} value={item.key}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );
        } else {
            return <TextField key={`${prop1}-${prop2}`} type={type || "string"} inputProps={{ style: { width: "100%", textAlign: "initial" } }} 
            InputProps={{startAdornment: 
                prop2 === "rate_of_return" ? <InputAdornment position="start">%</InputAdornment> :
                prop2 === "amount" ||  prop2 === "actual_earnings" ? <InputAdornment position="start">$</InputAdornment> : null
            }}
            value={
                form ? (prop2 && form[prop1] ? form[prop1][prop2] || "" :
                prop1 ? form[prop1] || "" : 
                form[prop2] || '') : ''
            } onChange={onHandleChange.bind(this, prop1, prop2)} label={label} size='small' color='primary' variant='outlined' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }}/>
        }
    };

    const getFields = (elements) => {
        return elements.map((obj, i) => {
            return (
                <Grid key={i} item xs={obj["fullWidth"] ? 12 : 6}>
                    {showFields(obj["section"], obj["key"], obj["label"], obj["type"], obj["catalog"])}
                </Grid>
            );
        });
    };

    return (
        <Dialog open={true} fullWidth sx={{ zIndex: zPos, filter: zPos !== 45 ? "blur(2px)" : "none" }}>
            <ModalStyle property={String(isValidForm)}>
                <DialogTitle>
                    <span>Crece con aH (Nota Convertible)</span>
                </DialogTitle>

                <DialogContent>
                    { !selectedForm && <Alert severity={"info"}>
                        A continuación selecciona la operación que deseas realizar.
                    </Alert>}
                    <Box my={2} display="flex" justifyContent="space-around" width="100%" gap={2}>
                        <Card sx={{ width: 200, height: "fit-content"}}>
                            <CardActionArea onClick={() => onSelectForm("create")} sx={{display: "flex", p: 1.5, backgroundColor: selectedForm === "create" ? "#e0ffdc" : "inherit"  }}> 
                                <PostAdd color="success" sx={{mx: 1.5}}/>
                                <Typography fontWeight={"bold"}>Crear Nota Convertible</Typography>
                            </CardActionArea>
                        </Card>
                        <Card sx={{ width: 200, height: "fit-content"}}>
                            <CardActionArea onClick={() => onSelectForm("complete")} sx={{display: "flex", p: 1.5, backgroundColor: selectedForm === "complete" ? "#e5f6fd" : "inherit"  }}> 
                                <Engineering color="primary" sx={{mx: 1.5}}/>
                                <Typography fontWeight={"bold"}>Cerrar Nota Convertible</Typography>
                            </CardActionArea>
                        </Card>
                    </Box>

                    {selectedForm === "complete" && 
                        <Box>
                        {!form["uuid"] && <Alert severity={"info"}>
                            Completa el campo con el UUID de Cliente.
                        </Alert>}

                        <TextField value={(searchForm && searchForm["customer_uuid"]) || ""} onChange={onHandleSearch.bind(this)} label={"UUID Cliente"} size='small' color='primary' variant='outlined' sx={{my: 2}} fullWidth InputLabelProps={{ shrink: true }}
                            InputProps={{ endAdornment: <IconButton onClick={onSearch}><SearchOutlined /></IconButton> }}
                        />
                        </Box>
                    }

                    {(selectedForm === "create" || (selectedForm === "complete" && form["uuid"])) && (
                        <>
                        <Divider sx={{mt: selectedForm === "complete" ? 0 : 2, mb: 3, "&::before, &::after": {borderColor: selectedForm === "complete" ? "primary.light" : "success.light"}}}>- - -</Divider>
                        <Grid container spacing={2}>
                            {getFields(selectedForm === "create" ? afbInvestmentCreate : afbInvestmentComplete)}
                        </Grid>
                        </>
                    )}

                    {error && <Typography variant="body2" color="orangered">{error}</Typography>}
                </DialogContent>

                <DialogActions sx={{justifyContent: "space-between"}}>
                    <Button onClick={onClose} variant='outlined' id='buttonCancel' sx={{padding: "10px 50px"}}>
                        Cancelar
                    </Button>
                    <Button onClick={onConfirm.bind(this)} disabled={isValidForm} variant="contained" sx={{padding: "10px 50px"}}>
                        Aceptar
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default AfbInvestmentAdmin;
